export const COMPLETED_FORM_STATUSES = ["complete", "finalised"];
//# sourceMappingURL=baseForm.js.map